import { GlobalClassKeys } from "assets/jss/common-styles";
import classes from 'classnames';
import * as React from "react";


interface IProps {
    disabled?: boolean;
    pointer?: "pointer" | "zoomIn" | "zoomOut" | "notAllowed";
    size?: "lg" | "md" | "sm" | "xs";
}

export type MuiClickableProps = IProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>;


const MuiClickable: React.FC<MuiClickableProps> = (props) => {
    const { children, className, disabled, pointer, size, onClick, ...rest } = props;
    const _pointer = disabled ? "notAllowed" : pointer;

    return (
        <span
            {...rest}
            onClick={onClick == null || disabled ? null : onClick}
            className={
                classes(
                    {
                        [className]: className != undefined,
                        [GlobalClassKeys.clickable]: props.onClick != null,
                        [GlobalClassKeys.mutedElement]: disabled === true,
                        [GlobalClassKeys.fontSizeLg]: size === "lg",
                        [GlobalClassKeys.fontSizeMd]: size === "md",
                        [GlobalClassKeys.fontSizeSm]: size === "sm",
                        [GlobalClassKeys.fontSizeXs]: size === "xs",
                        [_pointer]: _pointer != "pointer",
                    },
                )
            }
        >
            {children}
        </span>
    );
};

MuiClickable.defaultProps = {
    disabled: false,
    pointer: "pointer"
};

export default MuiClickable;
